export const supplyStages = [
  'raw_material',
  'work_in_progress',
  'finished_good'
]

export const DEFAULT_BAR_FORMAT = 'CODE39';
export const ORDERS_COUNT_LIMIT = 100;
export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm';
